import {
  CircularProgress,
  Dialog,
  DialogContent,
  type DialogProps,
  Flex,
  Text,
} from '@shared/components';

export type RevokeLocationLoadingModalProps = Pick<DialogProps, 'open'>;

export default function RevokeLocationLoadingModal(
  props: Readonly<RevokeLocationLoadingModalProps>,
) {
  const { open: isOpen } = props;
  return (
    <Dialog open={isOpen} sx={{ '& .MuiPaper-root': { width: '378px' } }}>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <CircularProgress />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'center' })}
        >
          <Text variant='h5'>กำลังตรวจสอบสิทธิ์การใช้งาน</Text>
          <Text color='secondary'>กรุณารอสักครู่ ระบบกำลังตรวจสอบข้อมูลสิทธิ์การใช้งานสถานที่</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
